import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import SeriesTimePicker from '../../series/components/SeriesTimePicker';
import { setSelectedChildEvent, setSelectedDate } from '../../series/actions/event-series';
import { getSeriesConfig } from 'checkout/selectors/ui';
import { getLowInventoryMessage, getSoldOutMessage, getEventTimeFormatted } from '../../series/selectors/eventSeries';
import { getSubState } from '../../../reducers/subReducerHelpers';
import KioskSeriesTimes from '../../kiosk/containers/KioskSeriesTimes';
import KioskableComponent from '../../kiosk/KioskableComponent';

class UpsellTimePicker extends KioskableComponent {

    onEventTimeChange = childEventId => {
        this.props.setSelectedChildEvent(childEventId, this.props.reducerKey);
    };

    renderOnline = () => {
        return (
            <div className="upsell__series-time-picker">
                <SeriesTimePicker
                    locale={this.props.locale}
                    eventTimes={this.props.eventTimes}
                    onEventTimeChange={this.onEventTimeChange}
                    selectedDay={this.props.selectedDay}
                    selectedDayDate={this.props.selectedDateObject}
                    calendarType={"calendar-button"}
                    showButtonTimeRanges={this.props.showButtonTimeRanges}
                    showSoldOut={this.props.showSoldOut}
                    selectedChildEvent={this.props.selectedChildEvent}
                    loading={this.props.loading}
                    getLowInventoryMessage={this.props.getLowInventoryMessage}
                    getSoldOutMessage={this.props.getSoldOutMessage}
                    getEventTimeFormatted={this.props.getEventTimeFormatted}
                    hasActiveInventoryFilter={false}
                />
            </div>
        );
    }

    renderKiosk = () => {

        const handleSelectTime = e => {
            let id = +e?.currentTarget?.value;
            this.props.eventTimes.forEach(eventTime => {
                if (id === +eventTime.id && eventTime.eventStatus == 'on_sale') {
                    this.onEventTimeChange(id);
                    this.props.onLoadChildEvent(id);
                }
            });
        };

        return (
            <KioskSeriesTimes
                selectedDate={this.props.selectedDate}
                eventTimes={this.props.eventTimes}
                locale={this.props.locale}
                getSoldOutMessage={this.props.getSoldOutMessage}
                getLowInventoryMessage={this.props.getLowInventoryMessage}
                getEventTimeFormatted={this.props.getEventTimeFormatted}
                onEventSelected={handleSelectTime}
                onChangeDate={() => {this.props.setSelectedDate(null, this.props.reducerKey)}}
                showSoldOut={this.props.showSoldOut}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const eventSeriesState = getSubState(state.eventSeries, ownProps.reducerKey)
    let showSoldOut = getSeriesConfig(state).showSoldOut;
    let eventTimes = Array.isArray(eventSeriesState.eventTimes) ? eventSeriesState.eventTimes : [];
    if(showSoldOut === false) {
        eventTimes = eventTimes.filter((event) => event.eventStatus !== "sold_out");
    }

    return {
        eventTimes,
        locale: state.intl.locale,
        showButtonTimeRanges: getSeriesConfig(state).showButtonTimeRanges,
        selectedChildEvent: eventSeriesState.selectedChildEvent,
        showSoldOut,
        selectedDate: eventSeriesState.selectedDate,
        selectedDateObject: eventSeriesState.selectedDateObject,
        getLowInventoryMessage: getLowInventoryMessage(state),
        getSoldOutMessage: getSoldOutMessage(state),
        getEventTimeFormatted: getEventTimeFormatted(state),
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setSelectedChildEvent,
        setSelectedDate,
    }, dispatch);
};

UpsellTimePicker.propTypes = {
    reducerKey: PropTypes.string.isRequired,
    onLoadChildEvent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpsellTimePicker)
